import { gql } from '@apollo/client'

export const MOD_COM_ACTUAL_FACING = gql`
  fragment ModComActualFacing on Actual {
    upc
    index
    vFacingUpcs
    distanceFromHome
  }
`
